import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
function useScrollAnimation() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    if (ref.current) {
      const elements = ref.current.querySelectorAll('.animate-on-scroll');
      elements.forEach((el, index) => {
        ;
        (el as HTMLElement).style.transitionDelay = `${index * 0.08}s`;
        observer.observe(el);
      });
    }
    return () => observer.disconnect();
  }, []);
  return ref;
}
function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
function HeroSection() {
  return <section className="hero" data-id="element-0">
      <div className="container" data-id="element-1">
        <div className="hero__grid" data-id="element-2">
          <div className="hero__content" data-id="element-3">
            <div className="hero__eyebrow" data-id="element-4">
              <div className="hero__eyebrow-line" data-id="element-5" />
              <span className="hero__eyebrow-text" data-id="element-6">
                Protocolo Científico 2026
              </span>
            </div>
            <h1 className="hero__title" data-id="element-7">
              Deja de tapar tus poros.
              <br data-id="element-8" />
              <span className="highlight" data-id="element-9">Resetea tu piel</span> desde adentro.
            </h1>
            <div className="hero__visual-mobile" data-id="element-10">
              <div className="hero__glow" data-id="element-11" />
              <img src="https://cdn.magicpatterns.com/uploads/aoLEqsm8hNV16tpudDPMSR/Acne-bundle-mk.png" alt="Acné Expert System - Mockup del Ebook" className="hero__mockup-main" data-id="element-12" />
            </div>
            <p className="hero__subtitle" data-id="element-13">
              El sistema de educación dermatológica más completo del mercado
              hispano. 20 capítulos + 3 bonos exclusivos para eliminar el acné
              adulto atacando la raíz: el eje intestino-hormonas-piel.
            </p>
            <div className="hero__stats" data-id="element-14">
              <div className="hero__stat" data-id="element-15">
                <span className="hero__stat-number" data-id="element-16">20</span>
                <span className="hero__stat-label" data-id="element-17">Capítulos</span>
              </div>
              <div className="hero__stat" data-id="element-18">
                <span className="hero__stat-number" data-id="element-19">5</span>
                <span className="hero__stat-label" data-id="element-20">Fases</span>
              </div>
              <div className="hero__stat" data-id="element-21">
                <span className="hero__stat-number" data-id="element-22">21d</span>
                <span className="hero__stat-label" data-id="element-23">Protocolo</span>
              </div>
              <div className="hero__stat" data-id="element-24">
                <span className="hero__stat-number" data-id="element-25">+3</span>
                <span className="hero__stat-label" data-id="element-26">Bonos</span>
              </div>
            </div>
            <div className="hero__cta-group" data-id="element-27">
              <button onClick={() => scrollToSection('pricing')} className="btn-primary" data-id="element-28">
                ⚡ Quiero Mi Acceso Ahora
              </button>
            </div>
            <div style={{
            marginTop: 16
          }} data-id="element-29">
              <span className="hero__guarantee" data-id="element-30">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8315B" strokeWidth="2" data-id="element-31">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-32" />
                </svg>
                Garantía de 7 días — Riesgo cero para ti
              </span>
            </div>
          </div>
          <div className="hero__visual" data-id="element-33">
            <div className="hero__glow" data-id="element-34" />
            <img src="https://cdn.magicpatterns.com/uploads/aoLEqsm8hNV16tpudDPMSR/Acne-bundle-mk.png" alt="Acné Expert System - Mockup del Ebook" className="hero__mockup-main" data-id="element-35" />
          </div>
        </div>
      </div>
    </section>;
}
function PainSection() {
  const ref = useScrollAnimation();
  const cards = [{
    icon: '😔',
    title: 'Cancelas por vergüenza',
    text: 'Evitas salir cuando tienes un brote. Sientes que todos miran tu piel antes que tus ojos.'
  }, {
    icon: '💸',
    title: 'Gastas sin resultados',
    text: 'Has probado cremas de $50, $80 y hasta $100 USD que prometían milagros y dejaron más irritación.'
  }, {
    icon: '🔄',
    title: 'El efecto rebote',
    text: 'Secas el grano hoy, mañana aparecen tres más. Nadie te explicó por qué sucede ni cómo detenerlo.'
  }];
  return <section className="pain section" ref={ref} data-id="element-36">
      <div className="container" data-id="element-37">
        <div className="pain__header" data-id="element-38">
          <span className="badge" data-id="element-39">¿Te identificas?</span>
          <h2 className="section-title" data-id="element-40">El ciclo que te tiene atrapada</h2>
          <div className="divider" style={{
          margin: '16px auto'
        }} data-id="element-41" />
          <p className="section-subtitle" style={{
          margin: '0 auto'
        }} data-id="element-42">
            Millones de mujeres gastan cientos de dólares en productos que
            tratan el síntoma, no la causa.
          </p>
        </div>
        <div className="pain__grid" data-id="element-43">
          {cards.map((card, i) => <div key={i} className="pain__card animate-on-scroll" data-id="element-44">
              <span className="pain__icon" data-id="element-45">{card.icon}</span>
              <h3 className="pain__card-title" data-id="element-46">{card.title}</h3>
              <p className="pain__card-text" data-id="element-47">{card.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function SolutionSection() {
  const checkItems = ['Diagnóstico clínico: identifica exactamente qué tipo de acné tienes', 'Protocolo nutricional de 7 días para apagar la inflamación', 'Rutina de skincare mínima pero clínicamente potente', 'Sistema para borrar manchas e hiperpigmentación', 'Guía de mantenimiento de por vida basada en tu ciclo'];
  return <section className="solution section" data-id="element-48">
      <div className="container" data-id="element-49">
        <div className="solution__grid" data-id="element-50">
          <div className="solution__visual" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/sSQKTWgjY58inqawg7TMNa/Acne-mk.png" alt="Acné Expert System" className="solution__mockup" loading="lazy" data-id="element-52" />
            <div className="solution__badge-float" data-id="element-53">
              <div className="solution__badge-float-number" data-id="element-54">20</div>
              <div className="solution__badge-float-text" data-id="element-55">
                Capítulos
                <br data-id="element-56" />
                Completos
              </div>
            </div>
          </div>
          <div className="solution__content" data-id="element-57">
            <span className="badge" data-id="element-58">La Solución</span>
            <h2 className="section-title" data-id="element-59">
              Presentamos el
              <br data-id="element-60" />
              <span data-id="element-61">Acné Expert System</span>
            </h2>
            <div className="divider" data-id="element-62" />
            <p className="section-subtitle" data-id="element-63">
              No es un simple PDF. Es una arquitectura progresiva de
              conocimiento donde cada fase construye sobre la anterior para una
              transformación profunda y duradera.
            </p>
            <ul className="solution__checklist" data-id="element-64">
              {checkItems.map((item, i) => <li key={i} className="solution__check-item" data-id="element-65">
                  <span className="solution__check-icon" data-id="element-66">✓</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
function PhasesSection() {
  const ref = useScrollAnimation();
  const phases = [{
    number: 'Fase 01',
    title: 'Los Cimientos',
    desc: 'Biología, microbioma y diagnóstico profundo de tu piel.',
    chapters: ['El ecosistema de la piel y microbioma', 'Taxonomía clínica del acné', 'Genética vs. Epigenética', 'Test de autodiagnóstico de barrera']
  }, {
    number: 'Fase 02',
    title: 'Alquimia Interna',
    desc: 'Nutrición clínica, hormonas y el eje intestino-piel.',
    chapters: ['El triángulo de la inflamación', 'La Biblia de la Insulina', 'Disruptores endocrinos en tu hogar', 'Protocolo de superalimentos']
  }, {
    number: 'Fase 03',
    title: 'Ingeniería de Producto',
    desc: 'El arte del skincare con activos de alta eficacia.',
    chapters: ['Diccionario de Activos 2.0', 'Doble Limpieza Médica', 'Exfoliación Química vs. Física', 'Vitamina C sin purga reactiva']
  }, {
    number: 'Fase 04',
    title: 'Intervención y Recuperación',
    desc: 'Lujo de farmacia, cicatrices, sol y psicodermatología.',
    chapters: ['Método "Lujo de Farmacia"', 'Gestión de Crisis en 24 horas', 'Borrando la hiperpigmentación', 'Psicodermatología: Cortisol y sebo']
  }];
  return <section className="content-block section" ref={ref} data-id="element-67">
      <div className="container" data-id="element-68">
        <div className="content-block__header" data-id="element-69">
          <span className="badge" data-id="element-70">El Contenido</span>
          <h2 className="section-title" data-id="element-71">
            5 Fases. Una <span data-id="element-72">Transformación Total.</span>
          </h2>
          <div className="divider" style={{
          margin: '16px auto'
        }} data-id="element-73" />
          <p className="section-subtitle" style={{
          margin: '0 auto'
        }} data-id="element-74">
            20 capítulos diseñados bajo estándares institucionales para atacar
            el acné desde cada ángulo posible.
          </p>
        </div>
        <div className="phases__grid" data-id="element-75">
          {phases.map((phase, i) => <div key={i} className="phase__card animate-on-scroll" data-id="element-76">
              <div className="phase__number" data-id="element-77">{phase.number}</div>
              <h3 className="phase__title" data-id="element-78">{phase.title}</h3>
              <p className="phase__desc" data-id="element-79">{phase.desc}</p>
              <ul className="phase__chapters" data-id="element-80">
                {phase.chapters.map((ch, j) => <li key={j} className="phase__chapter-item" data-id="element-81">
                    <span className="phase__chapter-arrow" data-id="element-82">→</span>
                    {ch}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function BonusesSection() {
  const ref = useScrollAnimation();
  const bonuses = [{
    img: 'https://cdn.magicpatterns.com/uploads/jizjWmasXC1rimoUfSFabn/Acne-b1.png',
    alt: 'Recetario Piel de Porcelana',
    label: 'Bono #1',
    title: 'Recetario Piel de Porcelana',
    desc: '15 recetas estratégicas para mantener tu insulina estable y tu hígado limpio. El 80% del acné se elimina con nutrición.',
    original: '$27 USD'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/vabathMnTiYgBE7aDp1NED/Acne-b2.png',
    alt: 'Guía Lujo de Farmacia',
    label: 'Bono #2',
    title: 'Guía Lujo de Farmacia',
    desc: 'Tabla de equivalencias para ahorrar un 70% en skincare sin sacrificar resultados clínicos. Deja de tirar tu dinero.',
    original: '$19 USD'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/fPUFSsKgKLTJepRFnTafAz/Acne-b3.png',
    alt: 'Bitácora 90 Días',
    label: 'Bono #3',
    title: 'Bitácora de 90 Días',
    desc: 'Rastreador imprimible de hábitos, alimentación y estado de la piel. Conviértete en el detective de tus propios brotes.',
    original: '$15 USD'
  }];
  const valueRows = [{
    label: '📘 Acné Expert System (20 caps)',
    price: '$97 USD'
  }, {
    label: '🥗 Recetario Piel de Porcelana',
    price: '$27 USD'
  }, {
    label: '🧴 Guía Lujo de Farmacia',
    price: '$19 USD'
  }, {
    label: '📝 Bitácora de 90 Días',
    price: '$15 USD'
  }];
  return <section className="bonuses section" ref={ref} data-id="element-83">
      <div className="container" data-id="element-84">
        <div className="bonuses__header" data-id="element-85">
          <span className="badge" data-id="element-86">Bonos Exclusivos</span>
          <h2 className="section-title" data-id="element-87">
            Compra el sistema, <span data-id="element-88">llévate el arsenal</span>
          </h2>
          <div className="divider" style={{
          margin: '16px auto'
        }} data-id="element-89" />
          <p className="section-subtitle" style={{
          margin: '0 auto'
        }} data-id="element-90">
            No solo te llevas el libro. Te llevas las herramientas que
            convierten el conocimiento en resultados visibles.
          </p>
        </div>
        <div className="bonuses__grid" data-id="element-91">
          {bonuses.map((bonus, i) => <div key={i} className="bonus__card animate-on-scroll" data-id="element-92">
              <img src={bonus.img} alt={bonus.alt} className="bonus__mockup-img" loading="lazy" data-id="element-93" />
              <div className="bonus__body" data-id="element-94">
                <div className="bonus__label" data-id="element-95">{bonus.label}</div>
                <h3 className="bonus__title" data-id="element-96">{bonus.title}</h3>
                <p className="bonus__desc" data-id="element-97">{bonus.desc}</p>
                <div className="bonus__value" data-id="element-98">
                  <span className="bonus__value-original" data-id="element-99">
                    {bonus.original}
                  </span>
                  <span className="bonus__value-free" data-id="element-100">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
        <div className="value-stack" data-id="element-101">
          <div className="value-stack__title" data-id="element-102">Lo que estás recibiendo hoy</div>
          {valueRows.map((row, i) => <div key={i} className="value-stack__row" data-id="element-103">
              <span className="value-stack__row-label" data-id="element-104">{row.label}</span>
              <span className="value-stack__row-price" data-id="element-105">{row.price}</span>
            </div>)}
          <div className="value-stack__total" data-id="element-106">
            <span className="value-stack__total-label" data-id="element-107">Valor Total Real:</span>
            <span className="value-stack__total-price" data-id="element-108">
              $158 USD → Solo $14.99
            </span>
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialsSection() {
  const ref = useScrollAnimation();
  const testimonials = [{
    text: '"Llevaba 4 años con acné hormonal y gastando en dermatólogo. Con este sistema en 3 semanas noté la diferencia más grande de mi vida. El capítulo de hormonas me abrió los ojos."',
    initial: 'V',
    name: 'Valentina R.',
    location: 'Bogotá, Colombia'
  }, {
    text: '"La guía de farmacia sola ya vale el precio completo. Dejé de gastar en cremas caras y reemplacé todo por $30 USD. Mi piel nunca había estado tan bien en 10 años."',
    initial: 'M',
    name: 'Mariana G.',
    location: 'CDMX, México'
  }, {
    text: '"Nunca imaginé que lo que comía afectara tanto mi piel. El protocolo de 7 días anti-inflamatorio fue un choque de realidad. En 21 días mis manchas bajaron un 60%."',
    initial: 'S',
    name: 'Sofía T.',
    location: 'Madrid, España'
  }];
  return <section className="proof section" ref={ref} data-id="element-109">
      <div className="container" data-id="element-110">
        <div className="proof__header" data-id="element-111">
          <span className="badge" data-id="element-112">Resultados Reales</span>
          <h2 className="section-title" data-id="element-113">
            Ellas ya <span data-id="element-114">lo lograron</span>
          </h2>
          <div className="divider" style={{
          margin: '16px auto'
        }} data-id="element-115" />
        </div>
        <div className="proof__grid" data-id="element-116">
          {testimonials.map((t, i) => <article key={i} className="testimonial animate-on-scroll" data-id="element-117">
              <div className="testimonial__stars" data-id="element-118">★★★★★</div>
              <p className="testimonial__text" data-id="element-119">{t.text}</p>
              <div className="testimonial__author" data-id="element-120">
                <div className="testimonial__avatar" data-id="element-121">{t.initial}</div>
                <div data-id="element-122">
                  <div className="testimonial__name" data-id="element-123">{t.name}</div>
                  <div className="testimonial__location" data-id="element-124">{t.location}</div>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="guarantee section" data-id="element-125">
      <div className="container" data-id="element-126">
        <div className="guarantee__inner" data-id="element-127">
          <div className="guarantee__seal" data-id="element-128">
            <span className="guarantee__seal-days" data-id="element-129">7</span>
            <span className="guarantee__seal-text" data-id="element-130">
              Días de
              <br data-id="element-131" />
              Garantía
              <br data-id="element-132" />
              Total
            </span>
          </div>
          <div data-id="element-133">
            <h2 className="guarantee__title" data-id="element-134">
              El riesgo es nuestro,
              <br data-id="element-135" />
              la piel radiante es tuya.
            </h2>
            <p className="guarantee__text" data-id="element-136">
              Si en los próximos 7 días sientes que el Acné Expert System no es
              la guía más completa y transformadora que has leído sobre tu piel,
              te devolvemos el 100% de tu inversión. Sin preguntas, sin
              formularios complicados, sin drama. Así de seguros estamos de lo
              que hemos construido.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function PricingSection() {
  const includes = ['Acné Expert System (20 Capítulos Completos)', 'Recetario Piel de Porcelana (Bono #1)', 'Guía Lujo de Farmacia (Bono #2)', 'Bitácora de 90 Días (Bono #3)', 'Acceso de por vida y actualizaciones incluidas'];
  return <section className="pricing section" id="pricing" data-id="element-137">
      <div className="container" data-id="element-138">
        <div className="pricing__card" data-id="element-139">
          <div className="pricing__label" data-id="element-140">🔥 Oferta de Lanzamiento</div>
          <h2 className="pricing__title" data-id="element-141">Acné Expert System</h2>
          <p className="pricing__subtitle" data-id="element-142">
            + Los 3 Bonos Exclusivos incluidos
          </p>
          <p className="pricing__original" data-id="element-143">Valor total: $158 USD</p>
          <div className="pricing__price" data-id="element-144">
            <sup data-id="element-145">$</sup>14
            <span style={{
            fontSize: 40
          }} data-id="element-146">
              .99
            </span>
          </div>
          <p className="pricing__currency" data-id="element-147">
            USD · Pago único · Acceso inmediato
          </p>
          <ul className="pricing__includes" data-id="element-148">
            {includes.map((item, i) => <li key={i} className="pricing__include-item" data-id="element-149">
                <span className="pricing__include-check" data-id="element-150">✓</span>
                {item}
              </li>)}
          </ul>
          <a href="#" className="pricing__cta" data-id="element-151">
            ⚡ SÍ — Quiero Mi Acceso Ahora Mismo
          </a>
          <p className="pricing__secure" data-id="element-152">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-153">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-154" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-155" />
            </svg>
            Pago 100% seguro · Hotmart · Tarjeta / PayPal / OXXO / Efecty
          </p>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const [openIndices, setOpenIndices] = useState<Set<number>>(new Set());
  const ref = useScrollAnimation();
  const faqs = [{
    q: '¿Esto funciona para acné de adultos, no solo adolescentes?',
    a: 'Sí. El Acné Expert System está diseñado específicamente para el acné adulto (hormonal, por estrés y reactivo), que es completamente diferente al acné juvenil. Tienes un capítulo entero dedicado a las diferencias biológicas y por qué los tratamientos juveniles no solo no funcionan, sino que empeoran el acné de adultos.'
  }, {
    q: '¿Necesito comprar productos caros para seguir el protocolo?',
    a: 'No. De hecho, uno de los tres bonos es la "Guía Lujo de Farmacia", donde te mostramos cómo replicar rutinas de $100 USD gastando menos de $30 USD con productos de farmacia local disponibles en México, Colombia y España.'
  }, {
    q: '¿En cuánto tiempo veré resultados reales?',
    a: 'Los primeros cambios (reducción de inflamación y enrojecimiento) se notan entre el día 7 y 14. La eliminación de manchas y cicatrices toma más tiempo (entre 45 y 90 días). Por eso incluimos la Bitácora de 90 Días, para que documentes tu progreso real.'
  }, {
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Inmediatamente después de tu pago a través de Hotmart o en cualquier plataforma donde esté alojado el producto, recibes un correo con los 4 archivos PDF (el sistema principal + los 3 bonos) y lo descargas al instante. Puedes leerlos en cualquier dispositivo: teléfono, tablet o computadora.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 7 días de garantía total. Si por cualquier razón no estás satisfecha con el contenido, solo escríbenos a nuestro correo de soporte y te devolvemos el 100% de tu inversión sin preguntas. El riesgo es completamente nuestro.'
  }];
  const toggle = useCallback((index: number) => {
    setOpenIndices(prev => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }, []);
  return <section className="faq section" ref={ref} data-id="element-156">
      <div className="container" data-id="element-157">
        <div className="faq__header" data-id="element-158">
          <span className="badge" data-id="element-159">Preguntas Frecuentes</span>
          <h2 className="section-title" data-id="element-160">
            Resolvemos tus <span data-id="element-161">dudas</span>
          </h2>
          <div className="divider" style={{
          margin: '16px auto'
        }} data-id="element-162" />
        </div>
        <div className="faq__list" data-id="element-163">
          {faqs.map((faq, i) => <div key={i} className={`faq__item ${openIndices.has(i) ? 'active' : ''}`} data-id="element-164">
              <button className="faq__question" aria-expanded={openIndices.has(i)} onClick={() => toggle(i)} data-id="element-165">
                {faq.q}
                <span className="faq__icon" data-id="element-166">+</span>
              </button>
              <div className="faq__answer" data-id="element-167">
                <div className="faq__answer-inner" data-id="element-168">{faq.a}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function FooterCTA() {
  return <>
      <section className="footer-cta" data-id="element-169">
        <div className="container" data-id="element-170">
          <h2 className="footer-cta__title" data-id="element-171">
            Tu piel{' '}
            <span style={{
            color: 'var(--red-primary)'
          }} data-id="element-172">
              merece
            </span>{' '}
            una solución real.
          </h2>
          <p className="footer-cta__text" data-id="element-173">
            No una crema más. No otro consejo de Instagram. Un sistema completo,
            probado y con garantía.
          </p>
          <button onClick={() => scrollToSection('pricing')} className="btn-primary" style={{
          margin: '0 auto'
        }} data-id="element-174">
            ⚡ Empezar Mi Transformación
          </button>
        </div>
      </section>
      <footer className="footer__bottom" data-id="element-175">
        <div className="container" data-id="element-176">
          <p data-id="element-177">
            © 2026 Acné Expert System · Todos los derechos reservados · Hotmart
            · <a href="#" data-id="element-178">Política de Privacidad</a> ·{' '}
            <a href="#" data-id="element-179">Términos de Uso</a>
          </p>
        </div>
      </footer>
    </>;
}
export function App() {
  return <div style={{
    width: '100%',
    background: 'var(--bg-dark)'
  }} data-id="element-180">
      <HeroSection data-id="element-181" />
      <PainSection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <PhasesSection data-id="element-184" />
      <BonusesSection data-id="element-185" />
      <TestimonialsSection data-id="element-186" />
      <GuaranteeSection data-id="element-187" />
      <PricingSection data-id="element-188" />
      <FAQSection data-id="element-189" />
      <FooterCTA data-id="element-190" />
    </div>;
}